<template>
    <div class="indexPage">
      <Slider></Slider>
      <Header></Header>
      <Index></Index>
      <Login></Login>

    </div>
</template>
<script>
  import Slider from '@/components/layout/slider.vue';
  import Header from '@/components/layout/header.vue';
  import Index from '../index.vue';
  import Login from '../login.vue';


  export default {
    data() {
      return {
        
      }
    },
    computed: {
      
    },
    methods:{
      
    },
    components:{
      Header,Slider,Index,Login
    }
  };
</script>
<style scoped lang="scss">
  .login{
    display:none;
  }
  .aside{
    float: left;
  }
  .el-header{
    margin-left: 2.87rem;
    /*position: relative;*/
    }
  .index{
    float: left;
    margin: 0.49rem 0 0 0.24rem;
    /*position: absolute;
    top: 1rem;
    left: 3.18rem;*/
  }
</style>



// WEBPACK FOOTER //
// src/views/indexPage/Index.vue